import React from 'react'
import CarePlanNextReviewField from '../../../../../../components/carePlans/CarePlanNextReviewField'
import styles from '../../CarePlanReiviewForm.styles'

import { CarePlan } from '@lmc/ts-common'

type SetFormField = {
  key: string
  value: string | number | string[] | boolean
}

interface ICarePlanReviewNextReview {
  setFormField: (update: SetFormField) => void
  fields: CarePlan
  FORM_ID: string
}

export const CarePlanReviewNextReview = ({
  setFormField,
  fields,
  FORM_ID,
}: ICarePlanReviewNextReview): React.ReactElement => (
  <div style={styles.sectionContainer}>
    <CarePlanNextReviewField
      fields={fields}
      formId={FORM_ID}
      setFormField={setFormField}
      style={{
        marginBottom: 24,
        marginTop: 24,
      }}
    />
  </div>
)

export default CarePlanReviewNextReview
